/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, n: NonNullable<unknown> }} Perks_Trigger_InvitesInputs */



/**
* | output |
* | --- |
* | "{count} members brought in" |
*
* @param {Perks_Trigger_InvitesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_trigger_invites = /** @type {((inputs: Perks_Trigger_InvitesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Trigger_InvitesInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") {
		const form = registry.plural("ru", i?.n, {}, true);
		if (form === "one") return /** @type {LocalizedString} */ (`${i?.count} приглашённый участник`);
		if (form === "few") return /** @type {LocalizedString} */ (`${i?.count} приглашённых участника`);
		if (form === "many") return /** @type {LocalizedString} */ (`${i?.count} приглашённых участников`);
		return /** @type {LocalizedString} */ (`${i?.count} приглашённого участника`)
	}
	return /** @type {LocalizedString} */ (`${i?.count} members brought in`)
});